import { useEffect, useState } from "react"
import { BrowserRouter, Route, Routes } from "react-router"

import { EVENTO_SESION, isAuthenticated } from "@/api/auth"
import { Layout } from "@/app/layout"
import { Providers } from "@/app/providers"
import { AliasesPage } from "@/features/aliases/aliases-page"
import { AppsPage } from "@/features/apps/apps-page"
import { LoginPage } from "@/features/auth/login-page"
import { CredentialsPage } from "@/features/credentials/credentials-page"
import { KeysPage } from "@/features/keys/keys-page"
import { OperatorsPage } from "@/features/operators/operators-page"
import { OrganizationPage } from "@/features/organization/organization-page"
import { ReconciliationsPage } from "@/features/reconciliations/reconciliations-page"
import { PricesPage } from "@/features/prices/prices-page"
import { TracesPage } from "@/features/traces/traces-page"
import { UsagePage } from "@/features/usage/usage-page"

export default function App() {
  const [autenticado, setAutenticado] = useState(isAuthenticated)

  // La sesión puede caerse desde cualquier petición, y por más motivos que caducar: a
  // quien está mirando la consola le pueden cambiar el rol o expulsarlo, y el gateway
  // invalida sus sesiones al momento por diseño. El cliente HTTP limpia la sesión y
  // avisa; escucharlo aquí es lo que evita que cada pantalla tenga que acordarse.
  useEffect(() => {
    const alCambiar = () => setAutenticado(isAuthenticated())
    window.addEventListener(EVENTO_SESION, alCambiar)
    return () => window.removeEventListener(EVENTO_SESION, alCambiar)
  }, [])

  if (!autenticado) {
    return (
      <Providers>
        <LoginPage onEntrar={() => setAutenticado(true)} />
      </Providers>
    )
  }

  return (
    <Providers>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout onSalir={() => setAutenticado(false)} />}>
            <Route index element={<UsagePage />} />
            <Route path="apps" element={<AppsPage />} />
            <Route path="apps/:appId" element={<KeysPage />} />
            <Route path="aliases" element={<AliasesPage />} />
            <Route path="prices" element={<PricesPage />} />
            <Route path="reconciliations" element={<ReconciliationsPage />} />
            <Route path="traces" element={<TracesPage />} />
            <Route path="organization" element={<OrganizationPage />} />
            {/* Estas dos rutas existen para todos los roles a propósito: quien no tenga
                el permiso ve el 403 del gateway, que es la respuesta correcta. Ocultar
                el enlace es comodidad; la decisión la toma el backend. */}
            <Route path="credentials" element={<CredentialsPage />} />
            <Route path="operators" element={<OperatorsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Providers>
  )
}
